<h2 class="center-page-heading">{{ "subscription_upgrade_plan_heading" | translate }}</h2>
<p class="center-page-description">{{ "subscription_upgrade_plan_description" | translate }}</p>

<div class="flex flex-wrap xl:mx-[-10rem] xxl:mx-[-15rem] 2xl:mx-[-20rem]">
    <div class="ml-6 mr-2 my-6 flex-none" style="min-width: 300px; width: 300px">
        <div class="card">
            <div class="m-4">
                <h5 class="mb-6">{{ "subscription_account_heading" | translate }}</h5>
                <p>
                    {{ "subscription_account_status" | translate }}:
                    <p-chip>{{ licenseStatusText }}</p-chip>
                </p>
                <p>
                    {{ "subscription_pro_seats_quantity" | translate }}:
                    <p-chip>{{ licenses }}</p-chip>
                </p>
                <p>
                    {{ "subscription_active_users" | translate }}:
                    <p-chip>{{ activeUsers }}</p-chip>
                </p>
                <p-button label="{{ 'subscription_manage_active_users_linktext' | translate }}" styleClass="p-button-link" (click)="linkToUsers()"></p-button>
                <br />
                <p-button label="{{ 'subscription_manage_billing_linktext' | translate }}" styleClass="p-button-link" (click)="linkToBilling()"></p-button>
            </div>
        </div>
    </div>

    <div class="mx-2 my-6 flex-1" style="max-width: 800px">
        <div class="card">
            <div class="mx-6 my-4">
                <div class="flex justify-between flex-wrap card-container">
                    <h5>{{ "subscription_pro_plan_heading" | translate }}</h5>
                    <p-selectButton
                        [allowEmpty]="false"
                        [ngModel]="yearly"
                        (onChange)="togglePricing($event.value)"
                        [options]="stateOptions"
                        optionLabel="label"
                        optionValue="value"
                    />
                </div>
                <p class="mb-8">{{ "subscription_pro_plan_description" | translate }}</p>

                <div class="grid grid-cols-12 gap-4 mt-1 mb-4">
                    <div class="col-span-1">
                        <div class="p-fluid">
                            <h3 *ngIf="isYearly()">{{ "subscription_pro_plan_price_yearly" | translate }}</h3>
                            <h3 *ngIf="!isYearly()">{{ "subscription_pro_plan_price_monthly" | translate }}</h3>
                        </div>
                    </div>
                    <div class="col-span-11">
                        <div class="p-fluid">
                            <p *ngIf="isYearly()">
                                {{ "subscription_pro_plan_per_seat_per_month" | translate }}<br />{{ "subscription_pro_plan_billed_annually" | translate }}
                            </p>
                            <p *ngIf="!isYearly()">
                                {{ "subscription_pro_plan_per_seat_per_month" | translate }}<br />{{ "subscription_pro_plan_billed_monthly" | translate }}
                            </p>
                            <p *ngIf="isYearly()" style="color: #179604">{{ "subscription_pro_plan_savings" | translate: { savings: savings } }}</p>
                        </div>
                    </div>
                </div>

                <p class="mt-6 mb-4">{{ "subscription_pro_plan_number_seats" | translate }}</p>
                <div class="p-fluid flex mb-12">
                    <div class="mr-6">
                        <p-inputNumber
                            class="input-number-width-90"
                            [(ngModel)]="addLicencesQuantity"
                            [showButtons]="true"
                            [min]="1"
                            inputId="stacked"
                            (onInput)="checkMinLicences()"
                        >
                        </p-inputNumber>
                    </div>
                    <div style="width: 100%">
                        <button pButton pRipple type="button" class="w-full" (click)="goToBuyLicence(this.addLicencesQuantity)">
                            {{ "button_subscription_pro_plan_upgrade" | translate }}
                        </button>
                    </div>
                </div>

                @if (minLicenseMessage) {
                    <p-message severity="warn" styleClass="mb-1 mt-6">
                        {{ "subscription_pro_plan_min_messsage" | translate: { minLicenseQuantity: minLicenseQuantity } }}
                    </p-message>
                }

                <p-divider></p-divider>

                <ul class="feature-list mt-8">
                    <li class="mb-6"><i class="feature-icon pi pi-clock"></i>{{ "subscription_pro_plan_unlock_features_track" | translate }}</li>
                    <li class="mb-6"><i class="feature-icon pi pi-chart-bar"></i>{{ "subscription_pro_plan_unlock_features_analytics" | translate }}</li>
                    <li class="mb-6"><i class="feature-icon pi pi-file-pdf"></i>{{ "subscription_pro_plan_unlock_features_reports" | translate }}</li>
                    <li class="mb-6"><i class="feature-icon pi pi-cloud-download"></i>{{ "subscription_pro_plan_unlock_features_export" | translate }}</li>
                    <li class="mb-6"><i class="feature-icon pi pi-lock"></i>{{ "subscription_pro_plan_unlock_team_features_permissions" | translate }}</li>
                    <li class="mb-6">
                        <i class="feature-icon pi pi-th-large"></i>{{ "subscription_pro_plan_unlock_features_integrationplatforms" | translate }}
                    </li>
                    <li class="mb-6"><i class="feature-icon pi pi-sitemap"></i>{{ "subscription_pro_plan_unlock_features_layers" | translate }}</li>
                    <li class="mb-6"><i class="feature-icon pi pi-envelope"></i>{{ "subscription_pro_plan_unlock_features_support" | translate }}</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="mx-2 my-6 flex-none" style="min-width: 300px; width: 300px">
        <div class="card">
            <div class="m-4">
                <img class="inline" src="/assets/images/buzzer/buzzer-16x9.png" width="60%" height="60%" alt="No data" />
                <h5>{{ "subscription_otional_addons_heading" | translate }}</h5>
                <p>{{ "subscription_otional_addons_description" | translate }}</p>
                <p-button label="{{ 'subscription_otional_addons_visit_linktext' | translate }}" styleClass="p-button-link" (click)="linkToAddons()"></p-button>
                <h5 class="mt-12">{{ "subscription_timebuzzer_connect_heading" | translate }}</h5>
                <p>{{ "subscription_timebuzzer_connect_description" | translate }}</p>
                <a href="{{ 'subscription_timebuzzer_connect_contact_link' | translate }}" target="_blank" rel="noopener">
                    {{ "subscription_timebuzzer_connect_contact_linktext" | translate }}
                </a>
            </div>
        </div>
    </div>
</div>

<div class="mt-12">
    <p-divider></p-divider>
</div>
<div class="mt-12">
    <div class="">
        <div class="mb-12">
            <h4>{{ "subscription_faq_heading" | translate }}</h4>
            <p>{{ "subscription_faq_description" | translate }}</p>
        </div>
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 my-4">
                <h5>{{ "subscription_faq_try_out" | translate }}</h5>
                <p>
                    {{ "subscription_faq_try_line1" | translate }}
                    {{ "subscription_faq_try_line2" | translate }}
                    {{ "subscription_faq_try_line3" | translate }}
                </p>
            </div>
            <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 my-4">
                <h5>{{ "subscription_faq_discount" | translate }}</h5>
                <p>
                    {{ "subscription_faq_discount_line1" | translate }}
                    {{ "subscription_faq_discount_line2" | translate }}
                    {{ "subscription_faq_discount_line3" | translate }}
                </p>
            </div>
            <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 my-4">
                <h5>{{ "subscription_faq_seats" | translate }}</h5>
                <p>
                    {{ "subscription_faq_seats_line1" | translate }}
                    {{ "subscription_faq_seats_line2" | translate }}
                    {{ "subscription_faq_seats_line3" | translate }}
                </p>
            </div>
            <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 my-4">
                <h5>{{ "subscription_faq_payment" | translate }}</h5>
                <p>
                    {{ "subscription_faq_payment_line1" | translate }}
                    {{ "subscription_faq_payment_line2" | translate }}
                    {{ "subscription_faq_payment_line3" | translate }}
                </p>
            </div>
            <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 my-4">
                <h5>{{ "subscription_faq_refund" | translate }}</h5>
                <p>
                    {{ "subscription_faq_refund_line1" | translate }}
                    {{ "subscription_faq_refund_line2" | translate }}
                    {{ "subscription_faq_refund_line3" | translate }}
                </p>
            </div>
            <div class="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6 my-4">
                <h5>{{ "subscription_faq_cancel" | translate }}</h5>
                <p>
                    {{ "subscription_faq_cancel_line1" | translate }}
                    {{ "subscription_faq_cancel_line2" | translate }}
                    {{ "subscription_faq_cancel_line3" | translate }}
                </p>
            </div>
        </div>
    </div>
</div>
